
import * as React from "react"
import { Label as ShadcnLabel } from "@/components/ui/label"
import { cn } from "@/lib/utils"

export interface EnhancedLabelProps extends React.ComponentPropsWithoutRef<typeof ShadcnLabel> {
  children: React.ReactNode;
  htmlFor?: string;
  className?: string;
}

export const EnhancedLabel = React.forwardRef<HTMLLabelElement, EnhancedLabelProps>(
  ({ className, children, htmlFor, ...props }, ref) => {
    return (
      <ShadcnLabel
        ref={ref}
        htmlFor={htmlFor}
        className={cn(className)}
        {...props}
      >
        {children}
      </ShadcnLabel>
    );
  }
);
EnhancedLabel.displayName = "EnhancedLabel";

export { EnhancedLabel as Label }
